if (!customElements.get('sc-breadcrumb')) {
  customElements.define('sc-breadcrumb', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.path = this.querySelector('ol');
      this.current = this.querySelector('[data-sc-current-crumb]');
      if (!this.path || !this.current) return;
      this.expanded = false;
      this.dataset.expanded = 'false';
      this.current.setAttribute('aria-expanded', 'false');
      const options = { signal: this.controller.signal };
      this.renderNavigationPath();
      document.addEventListener('sc:navigation-path-ready', () => this.renderNavigationPath(), options);
      this.addEventListener('click', event => {
        const crumb = event.target.closest('[data-sc-crumb]');
        if (crumb === this.current && (this.expanded || this.hasOverflow)) {
          this.setExpanded(!this.expanded);
        } else if (crumb && !this.expanded && crumb.scrollWidth > crumb.clientWidth + 1) {
          event.preventDefault();
          this.setExpanded(true);
        }
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.expanded) {
          this.setExpanded(false);
          this.current.focus({ preventScroll: true });
        }
      }, options);
      this.observer = new ResizeObserver(() => this.checkOverflow());
      this.observer.observe(this);
      requestAnimationFrame(() => this.checkOverflow());
      document.fonts?.ready.then(() => { if (this.isConnected) this.checkOverflow(); });
    }

    renderNavigationPath() {
      if (!window.SCNavigationPath || !this.dataset.productCollectionHandles) return;
      let collectionHandles;
      try { collectionHandles = JSON.parse(this.dataset.productCollectionHandles); } catch { return; }
      if (!Array.isArray(collectionHandles)) return;
      const branch = window.SCNavigationPath.productPath({ collectionHandles, fallbackHandle: this.dataset.fallbackCollectionHandle });
      const currentItem = this.current.closest('li');
      if (!currentItem) return;
      for (const item of Array.from(this.path.children).slice(1, -1)) item.remove();
      for (const node of branch.slice(0, 3)) {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = node.url;
        link.dataset.scCrumb = '';
        link.textContent = node.title;
        item.append(link);
        this.path.insertBefore(item, currentItem);
      }
      this.checkOverflow();
    }

    checkOverflow() {
      this.hasOverflow = [...this.querySelectorAll('[data-sc-crumb]')].some(crumb => crumb.scrollWidth > crumb.clientWidth + 1);
      this.dataset.overflow = String(this.hasOverflow);
    }

    setExpanded(expanded) {
      this.expanded = expanded;
      this.dataset.expanded = String(expanded);
      this.current.setAttribute('aria-expanded', String(expanded));
      this.checkOverflow();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}

